<template lang="pug">
  .hook-social
    .section
      .container
        .columns
          .column
            .block-center.has-text-centered(v-if="!success")
              h2 {{ gettext('An error occurred while authentication! Please contact with support, or try again later.') }}
            .block-center.has-text-centered(v-else)
              Loading
</template>
<script>
import Loading from '@/components/stretch-spinner'
import {gettext} from '@/services/TranslateHandler'

const moment = require('moment')

export default {
  name: 'SocialAuthLoginHook',
  components: {
    Loading
  },
  data () {
    return {
      success: true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      try {
        const redirect = vm.$route.query.next_login || vm.$route.query.next_signup || '/'
        vm.setRememberMe()
        await vm.$auth.refresh()
        vm.$auth.fetch() // Init fetch
        await vm.$auth.fetch()
        vm.$auth.watch.authenticated = true
        vm.$router.replace(redirect)
      } catch (e) {
        this.success = false
      }
    })
  },
  methods: {
    gettext: gettext,
    setRememberMe () {
      let expires = (moment().add(2, 'months')).toDate()
      document.cookie = `rememberMe=true; expires=${expires}; secure=true`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/hooks/social-auth-login/index.vue